<form class="slideInDown">
  <input type="text" #input (keyup)="search(input.value)" placeholder="Buscar Pokemon...">
  <img src="assets/Lupa.svg" alt="Buscar Pokemon...">
</form>
